import AdminService from '@/services/admin.service'

export default function(to, from, next) {
  AdminService.getRoles()
    .then(roles => {
      if (roles.findIndex(r => r.toLowerCase() === 'itsupport' || r.toLowerCase() === 'processmanager') > -1) {
        next()
      } else {
        next('/home')
      }
    })
    .catch(() => {
      next('/home')
    })
}
